import { Modal } from 'antd';
import axios from 'axios';
import { decodeToken } from 'react-jwt';
import { environment } from '../environments/environment';
import { API_ENDPOINTS } from '../shared/api-endpoints';
import { encryptInput } from '../shared/shared-functions';
const API = axios.create({
	baseURL: environment.APP_API_URL
});
let refreshTokenPromise: Promise<string> | null = null;

const refreshToken = async (): Promise<string> => {
	if (refreshTokenPromise === null) {
		refreshTokenPromise = (async (): Promise<string> => {
			const refreshToken:any = sessionStorage.getItem('refreshToken');
			// const accessToken:any = sessionStorage.getItem('accessToken'); 

			const authUser: any | null = localStorage.getItem("authUser") 
			? JSON.parse(localStorage.getItem("authUser") as string) 
			: null;
           
			try {
				const result = await axios.post(`${environment.APP_API_URL}${API_ENDPOINTS.APP_REFRESH_TOKEN}`, null, {
					headers: {
						'Content-Type': 'application/json',
						RefreshToken: refreshToken,
						Authorization: `Bearer ${authUser?.value?.AUTHTOKEN}`
					}
				});
			
				if (result.status === 200) {
					const newAccessToken = result?.data?.data?.accessToken;
					sessionStorage.setItem('accessToken', newAccessToken);
					return newAccessToken;
				} else {
					sessionStorage.clear();
					throw new Error('Token refresh failed');
				}
				
			} catch (error: any) {
				if (error.response?.status === 401) {
					sessionStorage.clear();
					Modal.warning({
						title: 'Your session has timed out!',
						content: `Please login again if necessary.`,
						onOk() {
							setTimeout(() => {
								window.location.href = '/';
							}, 100);
						}
					});
				}
				throw error;
			} finally {
				refreshTokenPromise = null;
			}
		})();
	}
	return refreshTokenPromise;
};

// Old Code for refernce
// const getBearerToken = async () => {
// 	try {
// 		const authUser: any | null = localStorage.getItem("authUser") 
// 			? JSON.parse(localStorage.getItem("authUser") as string) 
// 			: null;

// 		let token = authUser?.value;
// 		// let token = sessionStorage.getItem('accessToken');
// 		// let decodedToken: any = token ? decodeToken(token) : '';
// 		return token; 
// 		// if (decodedToken) {
// 		// 	// Calculate the expiration time difference in seconds
// 		// 	const expirationTime = new Date(decodedToken.exp * 1000); // Convert `exp` from seconds to milliseconds
// 		// 	const currentTime = new Date();

// 		// 	const timeDifferenceInSeconds = (expirationTime.getTime() - currentTime.getTime()) / 1000;

// 		// 	if (timeDifferenceInSeconds <= 0) {
				
				
// 		// 		return refreshToken(); 
// 		// 	} else {
// 		// 		return token; 
// 		// 	}
// 		// } else {
// 		// 	return null; 
// 		// }
// 	} catch (error) {
// 		console.error('Error in getting bearer token:', error);
// 		return error;
// 	}
// };

const getBearerToken = async () => {
	try {
		const authUser: any | null = localStorage.getItem("authUser") 
			? JSON.parse(localStorage.getItem("authUser") as string) 
			: null;

			if (authUser) {
				const expirationTime = authUser.expiryTime  // Convert exp to milliseconds
				const currentTime = new Date();
				// console.log("expirationTime====>",expirationTime)
				// console.log("currentTime====>",currentTime.getTime())
				// console.log("expirationTime <= currentTime====>",expirationTime <= currentTime)

				if (expirationTime <= currentTime.getTime()) {
					// Token is expired
					localStorage.removeItem("authUser");
					window.location.href = "/";
					return null;
				} else {
					return authUser?.value;
				}
			} 
	} catch (error) {
		console.error('Error in getting bearer token:', error);
		// localStorage.removeItem("authUser");
		// window.location.href = "/";
		return error;
	}
};

API.interceptors.request.use(
	async (config: any) => {
		const token = await getBearerToken();
		if (token) {
			return {
				...config,
				headers: {
					...config.headers,
					"X-Auth-Token": token?.AUTHTOKEN,
					"UserType": token?.USERGROUP
					// Authorization: `Bearer ${token}`
					// 'Ocp-Apim-Subscription-Key': ``
				}
			};
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

API.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		if (error?.response?.status === 401) {
			window.location.href = '/401';
		} else if (error?.response?.status === 403) {
			window.location.href = '/403';
		}
		return Promise.reject(error);
	}
);

export default API;